// removed by extract-text-webpack-plugin
module.exports = {"distanceText":"distanceText__mlG5k"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/CapacityCalculationView/styles.scss
// module id = 2284
// module chunks = 1